"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpgradeLink = void 0;

var _productProperties = _interopRequireDefault(require("ui-addon-upgrades/_core/common/constants/productProperties"));

var _links = require("ui-addon-upgrades/_core/common/navigation/links");

/**
 * @param {Object} upgradeData
 * @return {String}
 */
var getUpgradeLink = function getUpgradeLink(_ref) {
  var source = _ref.source,
      upgradeProduct = _ref.upgradeProduct;

  if (!upgradeProduct) {
    return (0, _links.productsAndAddons)();
  }

  var upgradeLink = _productProperties.default[upgradeProduct].upgradeLink;

  if (upgradeLink) {
    return upgradeLink(source, upgradeProduct);
  }

  return (0, _links.productsAndAddons)();
};

exports.getUpgradeLink = getUpgradeLink;